import { api } from "./api";
export type ProductFeature =
  | "homepage_package_v1"
  | "homepage_guest_first"
  | "after_game_practice"
  | "lobby_daily_practice"
  | "guest_practice_invitation"
  | "guest_progress_invitation";
export type Assignment = {
  key: string;
  arm: "control" | "variant";
  feature: ProductFeature;
  value: boolean;
  token: string;
};
export const productExperimentsEnabled =
  process.env.NEXT_PUBLIC_PRODUCT_EXPERIMENTS_ENABLED === "true";
// Serialize the initial cookie handshake when several feature surfaces mount at once.
let assignmentQueue: Promise<any> = Promise.resolve();
export function getProductAssignment(
  feature: ProductFeature,
): Promise<Assignment | null> {
  const request = assignmentQueue.then(async () => {
    const { data } = await api.post(
      "/experiments/assignment",
      { feature },
      { timeout: 5000 },
    );
    return data.assignment || null;
  });
  assignmentQueue = request.catch(() => null);
  return request;
}
export async function recordProductExposure(assignment: Assignment) {
  await api.post(
    "/experiments/exposure",
    { token: assignment.token },
    { timeout: 5000 },
  );
}
